import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "@phosphor-icons/react";
import SiteNav from "@/components/SiteNav";
import Seo, { agentJsonLd } from "@/lib/seo";
import api from "@/lib/apiClient";

export default function Neighborhoods() {
  const [hoods, setHoods] = useState([]);

  useEffect(() => {
    api.get("/neighborhoods").then((r) => setHoods(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  }, []);

  return (
    <div className="bg-background min-h-screen">
      <Seo
        title="NY Neighborhood Guides — Bronx, Westchester & Beyond"
        description="Local market guides for the Bronx, Yonkers, Mount Vernon, New Rochelle, Brooklyn and Queens from Lamar A. Whyte — live listings, pricing and honest local insight."
        path="/neighborhoods"
        jsonLd={agentJsonLd()}
      />
      <SiteNav />
      <div className="max-w-7xl mx-auto px-6 pt-28 pb-16">
        <p className="text-brand text-xs uppercase tracking-[0.3em] mb-3">Where I work</p>
        <h1 className="text-4xl md:text-5xl text-white">Neighborhood guides</h1>
        <p className="text-white/50 mt-3 max-w-2xl font-light">
          Real coverage areas, real data — live listings and honest local context for
          the neighborhoods I actually serve.
        </p>
        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="neighborhoods-grid">
          {hoods.map((n) => (
            <Link
              key={n.slug}
              to={`/neighborhoods/${n.slug}`}
              data-testid={`hood-card-${n.slug}`}
              className="group rounded-sm border border-white/5 bg-[#101116] p-6 hover:border-brand/40 transition-colors"
            >
              <p className="text-white text-xl flex items-center gap-2">
                <MapPin size={18} weight="duotone" className="text-brand" /> {n.name}
              </p>
              <p className="text-white/45 text-sm mt-2 font-light leading-relaxed line-clamp-3">{n.blurb}</p>
              <p className="mt-4 text-brand text-xs uppercase tracking-wider inline-flex items-center gap-1.5">
                Explore {n.name} <ArrowRight size={13} weight="bold" className="group-hover:translate-x-1 transition-transform" />
              </p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
